import styled from 'lib/styled';
import React from 'react';
import { FC } from 'react';
import { colors } from '../../Shared/Style/colors';
import { ReactComponent as Icon } from '../trash-simple.svg';

const ThemedTrashCan = styled(Icon)(({ theme }) => {
    return {
        height: '24px',
        width: '24px',
        '& path': {
            stroke: theme?.colors?.icons || colors.icons,
            strokeWidth: '3px',
        },
        '& line': {
            stroke: theme?.colors?.icons || colors.icons,
        },
    };
});
const TrashCan: FC = ({ ...rest }) => {
    return <ThemedTrashCan viewBox="0 0 48 48" {...rest} />;
};

export default TrashCan;
